import * as React from 'react';
import styled from "styled-components";
import {PropsWithChildren, useEffect} from "react";
import ReactDOM from 'react-dom';

const Dim = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    overflow: hidden;
`;

const Sheet = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    box-sizing: border-box;
    background-color: white;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
    padding: 16px 16px 50px;
`;

interface Props {
    handleClose: () => void;
}

export function BottomSheet(props: PropsWithChildren<Props>) {
    const el = document.createElement('div');
    el.style.position = 'fixed';
    el.style.top = '0';
    el.style.left = '0';
    el.style.width = '100vw';
    el.style.height = '100vh';
    el.style.zIndex = '99999';

    useEffect(() => {
        document.body.appendChild(el);
        return () => {
            document.body.removeChild(el);
        };
    }, [el]);

    function stop(e: any) {
        e.stopPropagation();
    }

    // BottomSheet 열었던 component 의 click 등 이벤트 발생하지 않도록, portal parent 에 이벤트 전달되지 않도록 bubbling 방지
    const content =
        <Dim onMouseDown={stop} onMouseUp={stop} onTouchStart={stop} onTouchEnd={stop} onTouchCancel={stop}>
            <div onClick={(e) => props.handleClose()}
                 style={{position: "absolute", top: 0, left: 0, right: 0, bottom: 0}}/>
            <Sheet>{props.children}</Sheet>
        </Dim>
    ;

    return ReactDOM.createPortal(content, el);
}